<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
import { FormKitNode } from '@formkit/core'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps<{
  modelValue: boolean
}>()
defineEmits(['update:modelValue'])

const node = ref<FormKitNode | undefined>()

const setNode = (n: FormKitNode) => (node.value = n)

watch(
  () => props.modelValue,
  (value) => {
    if (!node.value) return
    node.value.input(value)
  },
)
</script>
<template>
<FormKitLazyProvider config-file="true">

  <div class="field-marketing-consent">
    <Checkbox
      id="shop-marketing-consent-checkbox"
      name="marketingConsent"
      :label="t('shop.registrationPage.registrationForm.marketingConsentLabel')"
      :required="false"
      @change="$emit('update:modelValue', $event as boolean)"
      @node="setNode"
    />
  </div>

</FormKitLazyProvider>
</template>

<style lang="scss" scoped>
.field-marketing-consent {
  margin-bottom: 20px;
}
</style>
